import { convertStringToDate } from "@/app/(main)/(club)/mes-clubs/[id]/utils/utils";
import {
  EventLocalObject,
  EventWrite,
} from "@/TS/Interfaces/global_interfaces";

type TimePickerValue = { $d: number };
type MemberOption = { value?: string; "@id": string };

const toMemberIri = (member: MemberOption): string => {
  if (member.value) return member.value;
  return member["@id"];
};

export const fetchEditEvents = (data: EventLocalObject): EventWrite => {
  const date = convertStringToDate(data.dayofmonth!);
  const startDateRecomputed = new Date((data.startDate as TimePickerValue).$d);
  startDateRecomputed.setFullYear(date.getFullYear());
  startDateRecomputed.setMonth(date.getMonth());
  startDateRecomputed.setDate(date.getDate());
  data.startDate = startDateRecomputed.toISOString();

  const endDateRecomputed = new Date((data.endDate as TimePickerValue).$d);
  endDateRecomputed.setFullYear(date.getFullYear());
  endDateRecomputed.setMonth(date.getMonth());
  endDateRecomputed.setDate(date.getDate());
  data.endDate = endDateRecomputed.toISOString();

  data.absentMembers = (data.absentMembers as unknown as MemberOption[]).map(
    toMemberIri,
  );
  data.honoredMembers = (data.honoredMembers as unknown as MemberOption[]).map(
    toMemberIri,
  );
  data.notifyByEmail = !!data.notifyByEmail;

  delete data.dayofmonth;

  return data as EventWrite;
};
